import React from 'react';
import CheckPermission from './CheckPermission/CheckPermission';
//handle
import { currentModulesHandle } from '../../../../utils/CurrentModulesHandle';

const ModulesRoles = ({ currentModules, onModulesChange }) => {
  const modules = currentModulesHandle.map(baseModule => {
    const existing = currentModules?.find(m => m.module === baseModule.module);
    if (!existing) return baseModule;

    return {
      ...baseModule,
      ...existing,
      actions: {
        ...baseModule.actions,
        ...(existing.actions || {}),
      },
      special_actions: {
        ...baseModule.special_actions,
        ...(existing.special_actions || {}),
      },
    };
  });

  const compomnetCrudCheckbox = (action, moduleIndex, actionIndex) => {
    const actionName = Object.keys(action)[0];
    let nameModule = '';
    switch (actionName) {
      case 'create':
        nameModule = 'Crear';
        break;
      case 'read':
        nameModule = 'Leer';
        break;
      case 'status':
        nameModule = 'Activo/Inactivo';
        break;
      case 'update':
        nameModule = 'Actualizar';
        break;
      case 'delete':
        nameModule = 'Eliminar';
        break;
    }

    const handleOnChange = (e) => {
      const newModules = JSON.parse(JSON.stringify(modules));
      newModules[moduleIndex].actions[actionName] = e.target.checked;
      onModulesChange(newModules);
    }

    return (
      <CheckPermission
        key={`module-${moduleIndex}-crud-${actionName}`}
        label={nameModule.charAt(0).toUpperCase() + nameModule.slice(1)}
        checked={action[actionName]}
        onChange={handleOnChange}
      />
    )
  }

  const compomnetSpecialCheckbox = (action, actionName, moduleIndex) => {
    let nameModule = '';
    switch (actionName) {
      case 'export':
        nameModule = 'Exportar';
        break;
      case 'human_atention':
        nameModule = 'Atención Humana';
        break;
      case 'export_chat':
        nameModule = 'Exportar Chat';
        break;
      case 'delete_chat':
        nameModule = 'Eliminar Chat';
        break;
      case 'can_block_contact':
        nameModule = 'Bloquear Contacto';
        break;
      case 'create_chat':
        nameModule = 'Crear Chat';
        break;
      case 'filters':
        nameModule = 'Filtros';
        break;
      case 'link_documents_rh':
        nameModule = 'Link Documentos';
        break;
    }

    const handleOnChange = (e) => {
      const newModules = JSON.parse(JSON.stringify(modules));
      newModules[moduleIndex].special_actions[actionName] = e.target.checked;
      onModulesChange(newModules);
    }

    return (
      <CheckPermission
        key={`module-${moduleIndex}-special-${actionName}`}
        label={nameModule}
        checked={action[actionName]}
        onChange={handleOnChange}
      />
    )
  }

  return (
    <div className="flex flex-col gap-3 mt-6 w-full">
      {modules.map((module, index) => (
        <div
          key={index}
          className="rounded-xl p-4 w-full"
          style={{
            backgroundColor: '#12132a',
            border: '1px solid rgba(255,255,255,0.06)',
          }}
        >
          {/* Header del módulo */}
          <div className="flex flex-row items-center gap-3 mb-3">
            <span className="text-sm font-semibold" style={{ color: '#E8EAF0' }}>
              {module.module.charAt(0).toUpperCase() + module.module.slice(1)}
            </span>
            <CheckPermission
              label="Ver módulo"
              checked={module.view}
              onChange={(e) => {
                const newModules = JSON.parse(JSON.stringify(modules));
                newModules[index].view = e.target.checked;
                onModulesChange(newModules);
              }}
            />
          </div>

          {/* Acciones CRUD + especiales */}
          <div className="flex flex-row flex-wrap gap-2">
            {module.actions && Object.entries(module.actions).map(([key, value]) => (
              compomnetCrudCheckbox({ [key]: value }, index, key)
            ))}
            {module.special_actions && Object.entries(module.special_actions).map(([key, value]) => (
              compomnetSpecialCheckbox({ [key]: value }, key, index)
            ))}
          </div>
        </div>
      ))}
    </div>
  )

}

export default ModulesRoles
